import Title from "../title/title"
import Text from "../text/text"

const StructuredList = ({ type = "unordered", title, description, items = [], listTagProps  }) => {
  const ListTag = type === "ordered" ? "ol" : "ul"

  return (
    <>
      {title && <Title level={4}>{title}</Title>}
      {description && <Text>{description}</Text>}
      <ListTag {...listTagProps}>
        {items?.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ListTag>
    </>
  )
}

export default StructuredList
